@use '@/scss/underscore' as _;

.error {
  margin: _.unit(4) 0;
  color: var(--color-error-60);
}
